import { METRICS } from './marketPulseConstants';

export const MARKET_PULSE_WAITLIST_STORAGE_KEY = 'market_pulse_waitlist_registered';

export const MARKET_PULSE_COMING_SOON = {
  badge: 'به‌زودی',
  badgeEn: 'Coming Soon',
  title: 'نبض بازار',
  headline: 'ببینید در کجای بازار ایستاده‌اید؟',
  subheadline: 'عملکرد شعبه را کنار میانگین کسب‌وکارهای متصل با بازار ببینید.',
  cta: 'به من اطلاع بده',
  ctaFinal: 'اولین نفری باشید که خبر می‌گیرید',
  ctaHint: 'هنگام انتشار، مستقیم به شما اطلاع می‌دهیم.',
  ctaSubmitting: 'در حال ثبت…',
  ctaSuccess: 'ثبت شد! هنگام انتشار به شما اطلاع می‌دهیم.',
  ctaAlready: 'شما قبلاً در لیست انتظار ثبت شده‌اید.',
  ctaError: 'ثبت ناموفق بود. لطفاً دوباره تلاش کنید.',
  emailLabel: 'ایمیل',
  emailPlaceholder: 'ایمیل خود را وارد کنید',
  highlightsTitle: 'در یک نگاه',
  benefitsTitle: 'چه چیزی دریافت می‌کنید',
  storyTitle: 'چطور کار می‌کند',
  trustTitle: 'اعتماد و شفافیت',
  productDocCta: 'سند محصول',
  productDocHint: 'جزییات کامل داشبورد را در سند محصول ببینید.',
  privacyNote: 'داده بازار فقط تجمیعی است؛ هیچ کسب‌وکاری جداگانه نمایش داده نمی‌شود.',
  scrollHint: 'اسکرول کنید',
} as const;

/** مشخصات کلیدی محصول — بدون عدد ساختگی */
export const MARKET_PULSE_SOCIAL_STATS = [
  { value: '۴', label: 'شاخص کلیدی', suffix: 'فروش · سفارش · قیمت · سبد' },
  { value: '12', label: 'ماه روند', suffix: 'مقایسه ماه‌به‌ماه' },
  { value: '۱۰۰٪', label: 'تجمیعی', suffix: 'بدون افشای هویت' },
  { value: 'POS', label: 'داده واقعی', suffix: 'مستقیم از صندوق فروش' },
] as const;

export const MARKET_PULSE_BENEFIT_CARDS = [
  {
    id: 'position',
    title: 'جایگاه واقعی',
    description: 'در یک نگاه بفهمید جلوتر یا عقب‌تر از بازار هستید.',
    accent: 'from-violet-500/20 to-purple-600/5',
    icon: 'trending-up' as const,
  },
  {
    id: 'context',
    title: 'زمینه تصمیم',
    description: 'عددها را در کنار بازار ببینید، نه به‌تنهایی.',
    accent: 'from-indigo-500/20 to-blue-600/5',
    icon: 'bar-chart-3' as const,
  },
  {
    id: 'trend',
    title: 'روند 12 ماهه',
    description: 'مسیر رشد شعبه در برابر کل بازار، ماه‌به‌ماه.',
    accent: 'from-fuchsia-500/20 to-pink-600/5',
    icon: 'line-chart' as const,
  },
  {
    id: 'privacy',
    title: 'محرمانه',
    description: 'هیچ اطلاعاتی از کسب‌وکارها جداگانه نمایش داده نمی‌شود.',
    accent: 'from-emerald-500/15 to-teal-600/5',
    icon: 'shield' as const,
  },
] as const;

/** Scrollytelling — سه گام داستان */
export const MARKET_PULSE_STORY_STEPS = [
  {
    id: 'collect',
    step: '۰۱',
    tabLabel: 'جمع‌آوری',
    title: 'داده واقعی جمع می‌شود',
    description: 'فاکتورهای صندوق فروشگاهی شعبه و کسب‌وکارهای متصل، ماه‌به‌ماه پردازش می‌شوند.',
    icon: 'database' as const,
    details: [
      'داده مستقیم از POS — بدون ورود دستی',
      'پردازش ماه‌به‌ماه برای روند پایدار',
      'شعبه شما و بازار متصل، با یک منطق زمانی',
    ],
  },
  {
    id: 'compare',
    step: '۰۲',
    tabLabel: 'مقایسه',
    title: 'با بازار مقایسه می‌شود',
    description: 'چهار شاخص رشد شما کنار میانگین تجمیعی بازار قرار می‌گیرد.',
    icon: 'git-compare' as const,
    details: [
      'رشد فروش، تعداد سفارش، قیمت و سبد',
      'میانگین تجمیعی — بدون افشای هویت',
      'تفاوت شما با بازار به‌صورت درصد',
    ],
  },
  {
    id: 'decide',
    step: '۰۳',
    tabLabel: 'تصمیم',
    title: 'تصمیم می‌گیرید',
    description: 'می‌بینید کجا قرار گرفته اید!',
    icon: 'target' as const,
    details: [
      'جلوتر یا عقب‌تر از بازار — در یک نگاه',
      'تمرکز روی اهرم‌های واقعی: قیمت، بازاریابی، منو',
      'روند 12 ماهه برای تصمیم بلندمدت',
    ],
  },
] as const;

export const MARKET_PULSE_STORY_FLOW = [
  { id: 'pos', label: 'POS' },
  { id: 'aggregate', label: 'تجمیع' },
  { id: 'compare', label: 'مقایسه' },
  { id: 'decide', label: 'تصمیم' },
] as const;

export const MARKET_PULSE_KPI_LABELS = METRICS.map((m) => m.shortLabel);

/** اصول اعتماد — بدون نقل‌قول ساختگی */
export const MARKET_PULSE_TRUST_PRINCIPLES = [
  {
    id: 'aggregate',
    title: 'فقط داده تجمیعی',
    description:
      'میانگین بازار از فروش واقعی کسب‌وکارهای متصل محاسبه می‌شود — بدون افشای هویت هیچ کسب‌وکار.',
    icon: 'shield' as const,
  },
  {
    id: 'compare',
    title: 'مقایسه در کنار بازار',
    description:
      'عملکرد شعبه را کنار میانگین بازار ببینید تا بفهمید رشد شما از بازار جلوتر است یا عقب‌تر.',
    icon: 'git-compare' as const,
  },
] as const;
